import React from "react";
import PropTypes from "prop-types";
import { Tooltip, Alert } from "antd";
import { ellipsisString } from "../../utils/stringFormat";


export default function ErrorMessage(props) {
  const {
    message,
    length
  } = props;

  return message ? (
    <Tooltip
      placement="bottom"
      title={message}>
      <Alert type="error" message={ellipsisString(message, length)} style={{ marginBottom: '24px' }} />
    </Tooltip>
  ) : null
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
  length: PropTypes.number,
}

ErrorMessage.defaultProps = {
  message: null,
  length: 30,
}